const toggle = document.querySelector('.menu-toggle');
const menu = document.querySelector('.mobile-menu');
const close = document.querySelector('.menu-close');
function setMenu(open) {
  if (!toggle || !menu) return;
  toggle.setAttribute('aria-expanded', String(open));
  menu.hidden = !open;
  document.body.classList.toggle('menu-open', open);
  (open ? close : toggle)?.focus();
}
toggle?.addEventListener('click', () => setMenu(true));
close?.addEventListener('click', () => setMenu(false));
menu?.addEventListener('click', (event) => { if (event.target.closest('a')) setMenu(false); });
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

const subject = new URLSearchParams(window.location.search).get('subject');
const subjectSelect = document.querySelector('#ContactSubject');
if (subject && subjectSelect && [...subjectSelect.options].some((option) => option.value === subject)) subjectSelect.value = subject;

const motionItems = [...document.querySelectorAll('[data-motion]')];
if (document.documentElement.classList.contains('motion-ready') && 'IntersectionObserver' in window) {
  const motionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      motionObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8%', threshold: .12 });
  motionItems.forEach((item) => motionObserver.observe(item));
} else {
  motionItems.forEach((item) => item.classList.add('is-visible'));
}

document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('[data-slide]')];
  let index = 0;
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== index; });
  };
  carousel.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
  carousel.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
  let startX = 0;
  carousel.addEventListener('touchstart', (event) => { startX = event.changedTouches[0].clientX; }, { passive: true });
  carousel.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - startX;
    if (Math.abs(distance) > 45) show(index + (distance < 0 ? 1 : -1));
  }, { passive: true });
  let timer = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? null : setInterval(() => show(index + 1), 7000);
  carousel.addEventListener('mouseenter', () => { if (timer) clearInterval(timer); });
  carousel.addEventListener('focusin', () => { if (timer) clearInterval(timer); });
  show(0);
});
